module.exports = __webpack_public_path__ + "img/video_noplay.f617aba2.svg";